import { useCallback, useMemo } from "react";

import { VoucherLimitType } from "@/lib/gql/__generated__/graphql";

import * as Shared from "../../../../../_shared";

export const useVoucherIntervalPrepDates = () => {
	const { viewModel, onSetViewModel } = Shared.Model.Context.useMarketingVoucherEditContext();
	const { voucherLimitType, intervalPrepDates } = viewModel;

	const shouldShowIntervalPrepDatesSection = useMemo(
		() => voucherLimitType.value === VoucherLimitType.Interval,
		[voucherLimitType],
	);

	const onSetIntervalPrepDates = useCallback(
		(input: number | undefined) => {
			onSetViewModel([
				{
					key: "intervalPrepDates",
					value: {
						isEdited: true,
						value: input,
					},
				},
			]);
		},
		[onSetViewModel],
	);

	return {
		shouldShowIntervalPrepDatesSection,
		intervalPrepDates,
		onSetIntervalPrepDates,
	};
};
